import { render, staticRenderFns } from "./CreateRequest.vue?vue&type=template&id=a2e83506&scoped=true&"
import script from "./CreateRequest.vue?vue&type=script&lang=js&"
export * from "./CreateRequest.vue?vue&type=script&lang=js&"
import style0 from "./CreateRequest.vue?vue&type=style&index=0&id=a2e83506&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e83506",
  null
  
)

export default component.exports